var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiscordIconHead = function SvgDiscordIconHead(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#discord-icon-head_svg__a)",
    d: "M20.348 4.52c2.71 3.923 4.05 8.348 3.549 13.441a.08.08 0 0 1-.032.055 20 20 0 0 1-6.002 2.98.08.08 0 0 1-.084-.027 16 16 0 0 1-1.225-1.962.075.075 0 0 1 .04-.105 12.4 12.4 0 0 0 1.874-.877.075.075 0 0 0 .006-.125 10 10 0 0 1-.373-.288.07.07 0 0 0-.078-.01c-3.882 1.765-8.134 1.765-12.061 0a.08.08 0 0 0-.078.01q-.181.148-.372.288a.075.075 0 0 0 .008.125c.598.338 1.22.635 1.872.878a.074.074 0 0 1 .041.104 14 14 0 0 1-1.226 1.962.08.08 0 0 1-.084.028A20 20 0 0 1 .13 18.016a.08.08 0 0 1-.03-.055C-.32 13.554.532 9.093 3.644 4.518a.1.1 0 0 1 .032-.027c1.53-.691 3.17-1.2 4.885-1.49a.08.08 0 0 1 .079.036c.211.369.453.842.617 1.23a18.6 18.6 0 0 1 5.487 0c.164-.38.397-.861.608-1.23A.075.075 0 0 1 15.432 3c1.715.292 3.355.8 4.885 1.491a.06.06 0 0 1 .031.028m-10.171 8.378c.019-1.303-.946-2.38-2.157-2.38-1.201 0-2.157 1.068-2.157 2.38s.974 2.38 2.157 2.38c1.201 0 2.157-1.069 2.157-2.38m7.974 0c.02-1.303-.945-2.38-2.156-2.38-1.202 0-2.157 1.068-2.157 2.38s.974 2.38 2.157 2.38c1.21 0 2.156-1.069 2.156-2.38"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "discord-icon-head_svg__a",
    x1: 0,
    x2: 24,
    y1: 12,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F63EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B28DFF"
  })))));
};
export default SvgDiscordIconHead;